import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { type FieldValues, useFormContext } from 'react-hook-form';
import ActionFormContext from '../ActionFormContext';
import type { UseActionFormReturn } from '../useActionForm';
function useActionFormContext() {
  const $ = _c(5);
  const {
    setBusy,
    submit,
    defaultValues
  } = useContext(ActionFormContext) as Pick<UseActionFormReturn<T, TOperationSuccessResult>, 'setBusy' | 'submit' | 'defaultValues'>;
  const context = useFormContext();
  let t0;
  if ($[0] !== context || $[1] !== defaultValues || $[2] !== setBusy || $[3] !== submit) {
    t0 = {
      ...context,
      setBusy,
      submit,
      defaultValues
    };
    $[0] = context;
    $[1] = defaultValues;
    $[2] = setBusy;
    $[3] = submit;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}
export default useActionFormContext;